export default {
  sanMarino: '#232d64',
  gold: '#8f7833',
  alto: '#e0e0e0',
  white: '#fff',
  tundora: '#424242',
  tacao: '#f1b083',
  oddColor: '#eeeeee',
  evenColor: '#fff',
  danger: '#f44336',
};
